<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Tickets from "../../../mixins/Tickets";
import TicketCard from "../../../components/tickets/TicketCard";

let _ = require('lodash');

import axios from 'axios';

/**
 * View ticket component
 */
export default {
  page: {
    title: "Unassigned Tickets",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms, Tickets],
  components: {Layout, PageHeader, Loader, TicketCard},
  data() {
    return {
      title: "Unassigned Tickets",
      items: [
        {
          text: "Tickets",
          href: "#"
        },
        {
          text: "Unassigned Tickets",
          active: true
        }
      ],

      serverErrors: [],
      isLoading: false,
      tickets: null,
      isLoadingAgents: false,
      agents: [],

      searchQueryIsDirty: false,
      searchQuery: '',
      filters: {
        results_per_page: 30,
        status: null,
        priority: null,
        only_show_my_tickets: true,
        agent_id: null,
        layout: 'cards' // table or cards
      }
    };
  },
  computed: {
    ticketResults() {
      if (this.tickets) {
        return this.tickets.data;
      }
      return [];
    }
  },
  methods: {
    determineSearchParams(page) {
      let params = {
        q: this.searchQuery,
        page: page,
        results_per_page: this.filters.results_per_page,
        only_unassigned: true
      };

      return params;
    },

    loadTickets: _.debounce(function (page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.post(API_BASE + '/tickets/search', vm.determineSearchParams(page)).then(r => {
        vm.tickets = r.data;
        vm.isLoading = false;
        vm.searchQueryIsDirty = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }),

    loadAgents() {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoadingAgents = true;

      axios.get(API_BASE + '/users').then(r => {
        vm.isLoadingAgents = false;
        vm.agents = r.data;
      }).catch(e => {
        console.log(e);
        vm.isLoadingAgents = false;
        vm.setErrors(e);
      });
    },

    setup() {
      this.loadAgents();
      this.loadTickets();
    }
  },
  watch: {
    '$route': 'setup',
    searchQuery: function () {
      this.searchQueryIsDirty = true;
      this.loadTickets();
    },
    filters: {
      handler: function () {
        this.loadTickets();
      },
      deep: true
    }
  },
  created() {
    this.setup();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>

    <div class="row">
      <div class="col-lg-9">

        <!-- Table view -->
        <div v-if="filters.layout === 'table'" class="card">
          <div class="card-body">
            <!-- Filters -->
            <div class="row mb-3">
              <div class="col-sm-4">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..."/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <!-- / Filters -->

            <div v-if="isLoading||searchQueryIsDirty" class="text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>

            <div v-if="!(isLoading||searchQueryIsDirty)" class="table-responsive mb-0">
              <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Subject</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Difficulty</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ticket in ticketResults" :key="ticket.id">
                  <th scope="row">{{ ticket.id }}</th>
                  <td>{{ ticket.subject }}</td>
                  <td>{{ getHumanReadableTicketStatus(ticket.status) }}</td>
                  <td>{{ getHumanReadableTicketPriority(ticket.priority) }}</td>
                  <td>{{ ticket.difficulty }}</td>
                  <td class="text-right">
                    <!-- Button trigger modal -->
                    <button
                        type="button"
                        class="btn btn-itg btn-itg btn-sm"
                        @click="$router.push('/tickets/'+ticket.id)"
                    >
                      View
                    </button>
                  </td>
                </tr>
                <tr v-if="ticketResults.length === 0">
                  <th scope="row" colspan="7">
                    <span class="text-danger">No results</span>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
        <!-- / Table view -->

        <!-- Card view -->
        <div v-if="filters.layout === 'cards'">
          <!-- Filters -->
          <div class="row mb-3">
            <div class="col-sm-4">
              <div class="search-box mr-2 mb-2 d-inline-block">
                <div class="position-relative">
                  <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..."/>
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- / Filters -->

          <!-- Is Loading -->
          <div v-if="isLoading||searchQueryIsDirty" class="card">
            <div class="card-body text-center">
              <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>
          </div>
          <!-- / Is Loading -->

          <!-- Cards -->
          <div v-if="!(isLoading||searchQueryIsDirty)" class="card-results-wrapper">
            <ticket-card v-for="ticket in ticketResults" :key="ticket.id" :ticket="ticket"></ticket-card>
            <div class="card" v-if="ticketResults.length === 0">
              <div class="card-body">
                <b class="text-danger">No results</b>
              </div>
            </div>
          </div>
          <!--- / Cards -->
        </div>
        <!-- / Card view -->

        <pagination v-if="!(isLoading||searchQueryIsDirty) && tickets" :data="tickets" :limit="8"
                    @pagination-change-page="loadTickets"></pagination>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body p-4">
            <!-- Results per page -->
            <div class="form-group mb-3">
              <label for="results_per_page">Results To Show</label>
              <v-select v-model="filters.results_per_page" :clearable="false"
                        :options="[10,20,30,40,50,60,70,80,90,100]"></v-select>
            </div>
            <!-- / Results per page -->

            <!-- Layout -->
            <div class="form-group mb-3">
              <label for="layout">Layout</label>
              <v-select v-model="filters.layout" label="label"
                        :reduce="option => option.value"
                        :clearable="false"
                        :options="[{value: 'cards', label: 'Cards'}, {value: 'table', label: 'Table'}]"></v-select>
            </div>
            <!-- / Layout -->
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.main-content {
  overflow: visible;
}
</style>
